const types = {
    SET_LIST: '[DAILY] SET LIST',
    SET_VIEW: '[DAILY] SET VIEW',
    SET_LOGIN: '[DAILY] SET LOGIN'
}

export {
    types
}